
import server from '../../public/server/server'
const msgApi = {
    //----------------------短信管理-----------------------------------
    pageList:server.requestPath +  '/sysSmsOrder/list', // 分页查询订单列表
	save:server.requestPath+"/sysSmsOrder/save",//生成微信订单
	queryWxOrder:server.requestPath+'/sysSmsOrder/queryWxOrder',//从微信服务器获取订单状态，并更新当前系统订单状态
	month:server.requestPath+'/sysSms/month',//发送统计
	content:server.requestPath+'/sysSms/content',//发送记录
	sysSms:server.requestPath+'/sysSms/save',//短信记录
}

export {
    msgApi
}
